var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7877 10.8887C23.0846 11.1914 23.2509 11.6007 23.25 12.0269C23.2488 12.4531 23.0808 12.8615 22.7825 13.1627C22.4842 13.4642 22.0797 13.6342 21.6577 13.635H6.18518L11.8157 19.3204C12.1777 19.7341 12.305 20.3066 12.1524 20.837C12.0002 21.3675 11.5893 21.7821 11.064 21.9361C10.5387 22.0901 9.97198 21.9616 9.56193 21.5958L1.21827 13.1709L1.13292 13.0779C0.929071 12.8401 0.798546 12.5475 0.758359 12.2357C0.747214 12.1276 0.747214 12.0186 0.758359 11.9105C0.784464 11.5284 0.945492 11.1686 1.21153 10.8955L9.60775 2.40391C10.0178 2.03844 10.5845 1.90991 11.1098 2.06391C11.6351 2.21762 12.0461 2.63255 12.1983 3.16297C12.3508 3.6934 12.2235 4.26559 11.8612 4.67963L6.19144 10.4046H21.6639C22.0874 10.4085 22.4921 10.5825 22.7877 10.8887Z",
    fill: "#006FCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionLeft);
export default __webpack_public_path__ + "static/media/action-left.4795af94facfab8f927693c8826588b8.svg";
export { ForwardRef as ReactComponent };